import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ContextMenuPopover,
  Action
} from "shared/components/ContextMenuPopover";
import {
  FilterIcon,
  DiscountTag02Icon,
  UserAdd02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { useDiscounts } from "views/discounts/hooks/useDiscounts";
import { ActiveDiscountsModal } from "views/discounts/components/ActiveDiscountsModal";
import { ActionState } from "shared/utils/application-actions";
import { MenuRow } from "views/applications-id/components/LayoutHeader/components/MenuRow";

interface HeaderDropdownMenuProps {
  inviteApplicantAction: ActionState;
  canViewLead: boolean;
  leadId?: number | null;
  templateId: string;
  setShowInviteApplicantsModal: (isOpen: boolean) => void;
}

export const HeaderDropdownMenu = ({
  inviteApplicantAction,
  canViewLead,
  leadId,
  templateId,
  setShowInviteApplicantsModal
}: HeaderDropdownMenuProps) => {
  const navigate = useNavigate();
  const [showActiveDiscountCodes, setShowActiveDiscountCodes] = useState(false);

  const { data: availableDiscounts = [] } = useDiscounts({
    active: true,
    restriction_type: "template",
    template_id: templateId,
    enabled: showActiveDiscountCodes
  });

  const headerDropdownActions = useMemo(() => {
    const dropdownActions: Action[] = [];

    dropdownActions.push({
      title: (
        <MenuRow text="View discount codes" HugeIcon={DiscountTag02Icon} />
      ),
      className: "!py-2.5",
      onClick: () => setShowActiveDiscountCodes(true)
    });

    if (!inviteApplicantAction.hidden)
      dropdownActions.push({
        title: (
          <MenuRow
            text="Invite applicant"
            HugeIcon={UserAdd02Icon}
            isDisabled={inviteApplicantAction.disabled}
          />
        ),
        className: "!py-2.5",
        disabled: inviteApplicantAction.disabled,
        tooltip: inviteApplicantAction.tooltip,
        onClick: () => setShowInviteApplicantsModal(true)
      });

    if (canViewLead)
      dropdownActions.push({
        title: <MenuRow text="View lead" HugeIcon={FilterIcon} />,
        className: "!py-2.5",
        onClick: () => {
          if (leadId) navigate(`/leads/${leadId}`);
        }
      });

    return dropdownActions;
  }, [
    canViewLead,
    inviteApplicantAction,
    leadId,
    setShowInviteApplicantsModal,
    navigate
  ]);

  return (
    <>
      <ContextMenuPopover
        borderLess={false}
        actions={headerDropdownActions}
        placement="bottom-end"
        contentClassName="w-[275px]"
      />
      <ActiveDiscountsModal
        isOpen={showActiveDiscountCodes}
        onClose={() => setShowActiveDiscountCodes(false)}
        discounts={availableDiscounts}
      />
    </>
  );
};
